import React from 'react';

export default function StudioBlock({ apps }) {
  const shipping = apps.filter((a) => a.status === 'Now shipping').length;
  return (
    <section style={{ background: 'var(--bg-inverse)', color: 'var(--fg-inverse)', padding: '120px 32px' }}>
      <div style={{ maxWidth: 1080, margin: '0 auto' }}>
        <div style={{
          fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.18em',
          textTransform: 'uppercase', color: '#A3A3A3', marginBottom: 32,
        }}>02 — The studio</div>
        <p style={{
          fontFamily: 'var(--font-display)', fontWeight: 400,
          fontSize: 'clamp(36px, 4.5vw, 64px)', lineHeight: 1.15, letterSpacing: '-0.02em',
          color: '#FAFAFA', margin: 0, maxWidth: 920,
        }}>
          We make apps the way other people might make
          <em style={{ fontStyle: 'italic', color: '#FF4D00' }}> furniture</em> — slowly, on purpose, and only when we have something to say.
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 48, marginTop: 96 }}>
          {[
            { n: String(apps.length).padStart(2, '0'), l: 'apps in the portfolio' },
            { n: String(shipping).padStart(2, '0'), l: 'shipping today' },
            { n: '∞', l: 'ideas in the notebook' },
          ].map((s, i) => (
            <div key={i}>
              <div style={{
                fontFamily: 'var(--font-display)', fontSize: 80, lineHeight: 1,
                color: '#FAFAFA',
              }}>{s.n}</div>
              <div style={{
                fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.14em',
                textTransform: 'uppercase', color: '#A3A3A3', marginTop: 12,
              }}>{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
